import React from 'react';
import { motion } from 'framer-motion';
import { useUI } from '../../../redux/hooks';
import SideMenu from '../SideMenu';

const DashNavBar = () => {
  const { openSideMenu } = useUI();

  return (
    <div>
      {/* Top Navigation Bar */}
      <div className="flex items-center justify-between px-4 py-3">
        <div className="flex items-center">
          <div className="text-2xl font-bold text-gray-900">iustia</div>
        </div>

        <div className="flex items-center space-x-4">
          {/* Profile Button */}
          <motion.button
            className="p-2 text-gray-600 hover:text-gray-900 rounded-lg hover:bg-gray-100 transition-colors duration-200"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
              />
            </svg>
          </motion.button>

          {/* Menu Button */}
          <motion.button
            onClick={openSideMenu}
            className="p-2 text-gray-600 hover:text-gray-900 rounded-lg hover:bg-gray-100 transition-colors duration-200"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            aria-label="Menu"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg>
          </motion.button>
        </div>
      </div>

      {/* Side Menu */}
      <SideMenu isDashboard={true} />
    </div>
  );
};

export default DashNavBar;
